import { Validators } from "@angular/forms";

export class StandardizedValidators {

	// Expresión para validar urls sin el protocolo ->		/^[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/
	// Estoy usando la que requiere el protocolo porque la api lo verifica, y si le mandás una dirección sin https:// la devuelve por inválida
	static regexp_url = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/
	static regexp_numeric_with_dash = "^[\-0-9]*$";
	static regexp_numeric = "^[0-9]*$";
	static regexp_numeric_with_two_decimals = '^-?[0-9]\\d*(\\.\\d{1,2})?$';
	static above_zero = 0.0000000001;

	static addressStreet = StandardizedValidators.textWithLengthsOf(2, 60, true);
	static addressNumber = [Validators.required, Validators.maxLength(10)];		// Le dejo poner letras
	static addressFloor = [Validators.min(0), Validators.max(50)];				// Le dejo poner letras
	static addressApartment = [Validators.min(0), Validators.max(50)];
	static doc = [Validators.required, Validators.pattern(StandardizedValidators.regexp_numeric), Validators.minLength(7), Validators.maxLength(9)];
	static cuit_cuil = [Validators.required, Validators.pattern(StandardizedValidators.regexp_numeric), Validators.minLength(11), Validators.maxLength(11)];
	static email = [Validators.required, Validators.email];
	static fullName = StandardizedValidators.textWithLengthsOf(2, 80, true);;
	static password = [Validators.required, Validators.minLength(8), Validators.maxLength(24), Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[_@$!%*?&.:\"#/=\(\)])[A-Za-z\\d_@$!%*?&.:\"#/=\(\)]{1,}$")];
	static price = [Validators.required, Validators.min(StandardizedValidators.above_zero), Validators.max(999999999), Validators.pattern(StandardizedValidators.regexp_numeric_with_two_decimals)];
	static properName = StandardizedValidators.textWithLengthsOf(2, 40, true);
	static phoneNumber = [Validators.required, Validators.minLength(10), Validators.maxLength(18), Validators.pattern(StandardizedValidators.regexp_numeric)];
	static productDimensions = StandardizedValidators.positiveFloatUpTo(10000, true);
	static selectField = [Validators.required, Validators.pattern(StandardizedValidators.regexp_numeric)];
	static selectField_notRequired = [Validators.pattern(StandardizedValidators.regexp_numeric)];
	static url = [Validators.required, Validators.pattern(StandardizedValidators.regexp_url)];
	static zipCode = StandardizedValidators.textWithLengthsOf(4, 8, true);

	static positiveIntegerUpTo(n:number, required:boolean) {
		let a = [
			Validators.min(StandardizedValidators.above_zero),
			Validators.max(n),
			Validators.pattern(StandardizedValidators.regexp_numeric)
		];

		if (required)
			a.unshift(Validators.required);
			
		return a;
	}

	static positiveFloatUpTo(n:number, required:boolean) {
		let a = [
			Validators.min(StandardizedValidators.above_zero),
			Validators.max(n),
			Validators.pattern(StandardizedValidators.regexp_numeric_with_two_decimals)
		];

		if (required)
			a.unshift(Validators.required);
			
		return a;
	}

	static textWithLengthsOf(minLength:number, maxLength:number, required:boolean) {
		let a = [
			Validators.minLength(minLength),
			Validators.maxLength(maxLength)
		];

		if (required)
			a.unshift(Validators.required);

		return a;
	}

	static productPrice(shippingPrice:number) {
		return [
			Validators.required,
			Validators.min(shippingPrice),
			Validators.pattern(StandardizedValidators.regexp_numeric_with_two_decimals)
		];
	}
}